import { useNavigate } from 'react-router-dom';
import { OpenSiteInJBP } from '../../components/OpenSiteInJBP';
import { EHttpMethod, usePortalQuery } from '../../hooks/usePortalQuery';
import { EMpanAssignmentMode, SearchMeterPointDetails } from '../../types';
import { MeterPointDetailsForm } from '../MeterPointDetailsForm/MeterPointDetailsForm';
import { Button } from '@portal_components/components/Button';

interface ExpandedSearchResultProps {
  contractId: string;
  customerGroupId: string;
  mprn: string;
}

export const ExpandedSearchResult = ({ contractId, mprn, customerGroupId }: ExpandedSearchResultProps) => {
  const navigate = useNavigate();
  const { data: meterPointDetails, isLoading: meterPointDetailsLoading } =
    usePortalQuery<SearchMeterPointDetails>(
      EHttpMethod.GET,
      `meter-point-details/${contractId}/${mprn}`,
      `meter-point-details-${contractId}-${mprn}`,
      true,
      undefined,
      undefined,
      undefined,
      undefined,
      600000,
      600000
    );

  const handleEditButtonClicked = () => {
    navigate(`/edit/${customerGroupId}/${contractId}/${mprn}`);
  };

  if (meterPointDetailsLoading) {
    return <div>Loading...</div>;
  }

  if (!meterPointDetailsLoading && !meterPointDetails) {
    return <div>Failed to load meter point details</div>;
  }

  return (
    <>
      {!meterPointDetails.appointmentActive && (
        <div className="pb-1 text-feedback-red text-sm">No active appointment</div>
      )}
      {meterPointDetails.mprn && meterPointDetails.contractType && (
        <OpenSiteInJBP mpan={meterPointDetails.mprn} contractType={meterPointDetails.contractType} />
      )}
      <MeterPointDetailsForm<SearchMeterPointDetails>
        mpan={meterPointDetails.mprn ?? ''}
        customerGroupId={customerGroupId}
        contractId={contractId}
        existingMeterPointDetails={meterPointDetails}
        mode={EMpanAssignmentMode.VIEW}
      />
      <div className="pl-3">
        <Button text="Edit" primary onClick={handleEditButtonClicked} />
      </div>
    </>
  );
};
